<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="自定义字段"
        width="900px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap">
            <div class="left-con fl">
                <div>
                    <div>
                        <el-checkbox :indeterminate="checkAllIndeterminate" v-model="isCheckAll" @change="checkAllChange">全选</el-checkbox>
                    </div>
                    <div class="group-item ml20" v-for="item in configData" :key="item.name">
                        <div class="child-item mt6 mb6">
                            <el-checkbox
                                v-model="item.checked"
                                @change="handleCheck(item, $event)">
                                <span>{{item.label}}</span>
                            </el-checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-con fl">
                <div class="right-top relative">
                    已选 <span class="text-color-primary">{{checkedList.length}}</span> 个字段
                    <span class="clear-all-btn text-color-error pointer" @click="clearAll">清除全部</span>
                </div>
                <div class="right-bottom">
                    <div class="p6">
                        <draggable :list="checkedList" ghost-class="drag-ghost" group="field">
                            <p class="filter-item-field" v-for="item in checkedList" :key="item.name">
                                <el-tag size="small" type="info" class="tag-item ellipsis relative" :title="item.label">
                                    <span class="el-icon-rank mr10"></span>{{item.label}}
                                    <span v-if="!item.disabled" class="remove-btn text-color-error" title="删除" @click="removeField(item)">x</span>
                                </el-tag>
                            </p>
                        </draggable>

                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '自定义列(取消)' }">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20" v-matomo="{behaviorCategory: '标签管理('+apiTypeName+')',name: '自定义列(保存)' }">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import util from '@/libs/utils';
    import API from '@/api/baseInfo/tag.js';
    import Draggable from 'vuedraggable';
    export default {
        name: "CustomFieldModal",
        props:{
            config:Array,
            selectList:Array,
            fieldType:String,
            apiTypeName:String,
        },
        components:{
            Draggable,
        },
        data(){
            return {
                dialogVisible:false,
                configData:[],
                checkedList:[],
                submitLoading:false,
                isCheckAll:false,
                checkAllIndeterminate:true,
                include_list: ['account_name', 'account_id', 'app_status', 'account_status'],
                cache_list: [],
                isShow_account: false
            }
        },
        computed:{

        },
        methods:{
            showModal(){
                this.dialogVisible = true;
                let config = util.deepClone(this.config)||[];
                let selectList = this.selectList||[];

                let res_config = []
                let res_selectList = []

                if(this.fieldType == 'subproject_tag') {
                    this.isShow_account = config.some(item=>this.include_list.includes(item.name))
                    if(this.isShow_account) {
                        this.cache_list = config.filter(item=>this.include_list.includes(item.name)).map(item=>{
                            return {
                                name:item.name,
                                label:item.label,
                            }
                        });
                        config.push({name: 'account', label: '账户', checked: false})
                    }
                    res_config = config.filter(item=>!this.include_list.includes(item.name))
                    res_selectList = selectList.filter(item=>!this.include_list.includes(item.name))
                }else{
                    res_config = config
                    res_selectList = selectList
                }

                this.configData = res_config.map(item=>{
                    item.checked = selectList.map(item=>item.name).includes(item.name);
                    return item;
                });

                this.checkedList = res_selectList.map(item=>{
                    let actionItem = this.configData.find(field=>field.name==item.name)||{};
                    return {
                        name:actionItem.name,
                        label:actionItem.label,
                    }
                });

                this.updateAllSelectStatus();
            },
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm() {
                this.configData = [];
                this.checkedList = [];
                this.isCheckAll = false;
                this.checkAllIndeterminate = true;
            },
            handleSubmit(){
                if(this.checkedList.length<=0){
                    return this.$message.error('自定义字段最少选择一项');
                }
                this.submitLoading = true;
                API.setCustomField({
                    field_type:this.fieldType,
                    fields:this.checkedList.map(item=>item),
                }).then(()=>{
                    // if(this.isShow_account) {
                    //     console.log('结果1', this.checkedList)
                    //     let find_index = this.checkedList.findIndex(item=>item.name === 'account')
                    //     let deep_list = cloneDeep(this.checkedList)
                    //     deep_list.splice(find_index,1, ...this.cache_list)
                    //     console.log('结果2', deep_list)
                    //     this.$emit('save',deep_list);
                    // }else {
                    //     this.$emit('save',this.checkedList);
                    // }
                    this.$emit('save',this.checkedList);
                    this.dialogVisible = false;
                    this.submitLoading = false;
                },err=>{
                    console.log('setCustomField err',err);
                    this.$message.error(err.info||'请求失败');
                    this.submitLoading = false;
                });
            },

            checkAllChange(val){
                this.checkAllIndeterminate = false;
                this.configData.forEach(item=>{
                    this.handleCheck(item,val,true);
                })
            },
            handleCheck(item,val){
                console.log('check',item.name,val);
                let actionItem = this.configData.find(inner=>inner.name==item.name);
                actionItem.checked = val;

                let index = this.checkedList.findIndex(inner=>inner.name==item.name);
                if(val){
                    if(index<0){
                        this.checkedList.push({
                            name:item.name,
                            label:item.label,
                        })
                    }
                }else{
                    if(index>=0){
                        this.checkedList.splice(index,1);
                    }
                }
                this.updateAllSelectStatus();
            },
            updateAllSelectStatus(){
                this.isCheckAll = this.configData.every(item=>item.checked);
                this.checkAllIndeterminate = this.checkedList.length>0&&this.checkedList.length<this.configData.length;
            },
            removeField(item){
                this.handleCheck(item,false);
            },
            clearAll(){
                this.configData.forEach(group=>{
                    group.checked = false;
                });
                this.checkedList = [];
                this.checkAllIndeterminate = false;
                this.isCheckAll = false;
            },
        }
    }
</script>

<style lang="scss" scoped>
.content-wrap{
    height: 360px;
    border: 1px solid #dcdee2;
    .left-con,.right-con{
        font-size: 12px;
        height: 100%;
    }
    .left-con{
        padding: 5px 10px;
        width: calc(100% - 200px);
        border-right: 1px solid #dcdee2;
        overflow-x: hidden;
        overflow-y: auto;
        .group-item{
            display: inline-block;
        }

        .child-item{
            min-width: 175px;
        }

    }
    .right-con{
        width: 200px;
        overflow-x: hidden;
        overflow-y: auto;

        .right-top{
            border-bottom: 1px solid #dcdee2;
            text-indent: 5px;
            height: 32px;
            line-height: 32px;
            .clear-all-btn{
                position: absolute;
                right: 5px;
                top: 0;
            }
        }
        .right-bottom{
            height: calc(100% - 32px);
            overflow-y: auto;

            .tag-item{
                //width: 160px;
                width: 100%;
            }

            .remove-btn{
                position: absolute;
                right: 5px;
                top: 0;
                cursor: pointer;
                padding: 0 5px;
            }


            ::v-deep .drag-ghost .tag-item{
                border-color: #999!important;
                border-style: dashed!important;
                background-color: #ccc!important;
                position: relative;
            }

        }





    }
}
</style>
